import React, { useState, useEffect, useRef } from "react";

export default function UserDropdown({
  placeholderLabel,
  selected,
  setSelected,
  options,
  open,
  setOpen,
  className
}) {
  const [search, setSearch] = useState("");
  const [position, setPosition] = useState("bottom"); // bottom or top
  const dropdownRef = useRef(null);
  const containerRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(e.target)
      ) {
        setOpen(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Auto-detect dropdown position
  useEffect(() => {
    if (open && containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      // Assume dropdown height ~200px (max-h-48)
      if (spaceBelow < 200 && spaceAbove > 200) {
        setPosition("top");
      } else {
        setPosition("bottom");
      }
    }
  }, [open]);

  const filtered = options.filter((user) =>
    (user.firstname + ' ' + user.lastname).toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="relative w-full" ref={containerRef}>
      {open && (
        <div
          ref={dropdownRef}
          className={`absolute left-0 w-full bg-white dark:bg-surface-dark-2 border border-border-primary rounded-md shadow z-10 ${position === "bottom" ? "top-full mt-2" : "bottom-[20px] mb-2"
            }`}
        >
          {/* Search box */}
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search user"
            autoFocus={true}
            className="w-full px-3 py-2 text-sm border-b border-gray-200 focus:outline-none"
          />

          {/* List */}
          <div className="max-h-48 overflow-y-auto">
            {filtered.map((user) => (
              <div
                key={user.id}
                onClick={() => {
                  setSelected(user);
                  setOpen(false);
                  setSearch("");
                }}
                className={`px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 ${selected?.includes(user.id) ? "bg-gray-100 dark:!bg-surface-panel" : ""
                  }`}
              >
                {user.firstname} {user.lastname}
              </div>
            ))}

            {filtered.length === 0 && (
              <div className="px-3 py-2 text-sm text-gray-400">
                No match found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
